module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"is-plain-object","commonjs2":"is-plain-object","amd":"is-plain-object","root":"isPlainObject"}
// module id = 13
// module chunks = 0